import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
//import Divider from '@material-ui/core/Divider';
//import { listScheduled } from './../video/api-video';
import Typography from '@material-ui/core/Typography';

import MyChannels from './../video/MyChannels';
import homeImg from './../assets/images/vic-boat.png';
import config from '../config';
import { useVideoContext } from '../libs/contextLib';

const useStyles = makeStyles((theme) => ({
  card: {
    maxWidth: 600,
    margin: 'auto',
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
  },
  title: {
    padding: `${theme.spacing(3)}px ${theme.spacing(2.5)}px ${theme.spacing(2)}px`,
    color: theme.palette.openTitle,
  },
  media: {
    minHeight: 400,
  },
  gridList: {
    width: '100%',
    minHeight: 200,
    padding: '16px 0 10px',
  },
  tile: {
    textAlign: 'center',
  },
  image: {
    height: '100%',
  },
  tileBar: {
    backgroundColor: 'rgba(0, 0, 0, 0.72)',
    textAlign: 'left',
  },
  enrolledTitle: {
    color: '#efefef',
    marginBottom: 5,
  },
  action: {
    margin: '0 10px',
  },
  enrolledCard: {
    backgroundColor: '#616161',
  },
  divider: {
    marginBottom: 16,
    backgroundColor: 'rgb(157, 157, 157)',
  },
  noTitle: {
    color: 'lightgrey',
    marginBottom: 12,
    marginLeft: 8,
  },
}));

export default function Home() {
  const classes = useStyles();
  const { state, dispatch } = useVideoContext();
  console.log('Home start state=', state);

  function noauthHome() {
    console.log('noauthHome start state=', state);
    const HOME_URL = config.web.KNHHOME_URL;
    //console.log('Home URL=', `"${HOME_URL}"`);
    return (
      <Card className={classes.card}>
        <Typography variant="h6" className={classes.title}>
          Home Page
        </Typography>
        <CardMedia className={classes.media} image={homeImg} title="UPenn Love" />
        <Typography variant="body2" component="p" className={classes.credit} color="textSecondary">
          Photo by{' '}
          <a
            href={ HOME_URL }
            target="_blank"
            rel="noopener noreferrer"
          >
            CS Kim
          </a>{' '}
        </Typography>
        <CardContent>
          <Typography variant="body1" component="p">
            Welcome to the "Open Experiment" home page.
          </Typography>
        </CardContent>
      </Card>
    );
  }
  function authHome() {
    console.log('authHome start state=', state);
    return <MyChannels />;
  }
  return <div>{authHome()}</div>;
}
